// extracted by mini-css-extract-plugin
module.exports = {"root":"PeopleDirectory_root__1dIbP","frame":"PeopleDirectory_frame__2ymqH"};